import { restClient } from '@/Core'

import { toShareRow } from '../Helpers/diskResponse'

import type { DiskRole } from '../Contracts/DiskNode'
import type { DiskPrincipalType, DiskShareRow } from '../Contracts/DiskShare'

export interface CreateDiskShareParams {
    principalType: DiskPrincipalType
    /** Uuid співробітника чи відділу, код ролі; для компанії — `null`. */
    principal: string | null
    role: DiskRole
    /** `YYYY-MM-DD` (до кінця дня) чи ISO 8601; `null` — без строку. */
    expiresAt: string | null
    notify: boolean
}

/** Надати доступ — один рядок за запит: `POST /services/disk/nodes/{uuid}/shares`. */
export const CreateDiskShareTask = async (uuid: string, params: CreateDiskShareParams): Promise<DiskShareRow> => {
    const response = (await restClient.post(`/services/disk/nodes/${encodeURIComponent(uuid)}/shares`, {
        json: {
            principalType: params.principalType,
            ...(params.principal !== null ? { principal: params.principal } : {}),
            role: params.role,
            expiresAt: params.expiresAt,
            notify: params.notify,
        },
    })) as unknown

    return toShareRow(response)
}
